var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn-toggle',[_c('v-btn',{staticClass:"export-btn",attrs:{"title":"Dowload in .csv format. Works on all devices"},on:{"click":function($event){return _vm.exportToFile(_vm.data,_vm.fileName,'csv')}}},[_c('v-icon',[_vm._v("mdi-file-delimited")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }